import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, ShoppingCartIcon, CoffeeIcon, ArrowRightLeftIcon } from 'lucide-react';
const deliverables = [{
  icon: BookOpenIcon,
  title: 'El Recetario Rejuvenece (PDF)',
  description: '21 recetas detalladas de desayunos latinos (Arepas de oro, Tortillas de poder, Pudines tropicales) 100% libres de gluten y azúcares inflamatorios.',
  color: 'text-sage',
  bg: 'bg-sage/10'
}, {
  icon: ShoppingCartIcon,
  title: 'La Guía del Súper en USA',
  description: 'Una lista exacta de qué marcas comprar en Walmart, Target o Costco para no equivocarte.',
  color: 'text-terracotta',
  bg: 'bg-terracotta/10'
}, {
  icon: CoffeeIcon,
  title: 'Manual de Infusiones de Oro',
  description: 'Bebidas naturales para deshinchar tu vientre en menos de 20 minutos cada mañana.',
  color: 'text-gold',
  bg: 'bg-gold/10'
}, {
  icon: ArrowRightLeftIcon,
  title: 'Tabla de Equivalencias',
  description: 'Cómo cambiar la harina de maíz o trigo por harinas que tus articulaciones amarán.',
  color: 'text-espresso',
  bg: 'bg-espresso/10'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatYouGet() {
  return <section className="py-20 px-4 bg-light-sage" data-id="element-122">
      <div className="max-w-6xl mx-auto" data-id="element-123">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-sage" data-id="element-124">
          LO QUE RECIBIRÁS HOY:
        </h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid md:grid-cols-2 gap-8" data-id="element-125">
          {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-3xl shadow-warm flex flex-col sm:flex-row gap-6 items-start" data-id="element-126">
              <div className={`p-4 rounded-2xl ${item.bg} shrink-0`} data-id="element-127">
                <item.icon className={`w-8 h-8 ${item.color}`} data-id="element-128" />
              </div>
              <div data-id="element-129">
                <h3 className="text-2xl font-bold mb-3" data-id="element-130">{item.title}</h3>
                <p className="text-lg text-espresso/80" data-id="element-131">{item.description}</p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}